import React from 'react';
import PropTypes from 'prop-types';
// import Drawer from '@material-ui/core/Drawer';
// import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
// import List from '@material-ui/core/List';
// import Typography from '@material-ui/core/Typography';
// import Divider from '@material-ui/core/Divider';
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {CustomersAsListItems} from './multiBoardWrapListData';
// import BreachBoardContent from "./BreachBoardContent";
// import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    position: 'relative',
  },
  // appFrame: {
  //   position: 'relative',
  //   display: "flex",
  //   width: '100%',
  //   height: '100%',
  //
  // },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    position: 'absolute',
//     height: '100%',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    width: '1000px',
    padding: theme.spacing(0),
    // marginTop: 56,
    // [theme.breakpoints.up('sm')]: {
    //   content: {
    //     height: 'calc(100% - 64px)',
    //     marginTop: 64,
    //   },
    // },
    // transition: theme.transitions.create('margin', {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    marginLeft: -drawerWidth,
  },
  // content: {
  //   width: '100%',
  //   marginLeft: -drawerWidth,
  //   flexGrow: 1,
  //   padding: theme.spacing(0),
  //   transition: theme.transitions.create('margin', {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.leavingScreen,
  //   }),
  //   marginTop: 56,
  //   [theme.breakpoints.up('sm')]: {
  //     content: {
  //       height: 'calc(100% - 64px)',
  //       marginTop: 64,
  //     },
  //   },
  // },
  contentShift: {
    // transition: theme.transitions.create('margin', {
    //   easing: theme.transitions.easing.easeOut,
    //   duration: theme.transitions.duration.enteringScreen,
    // }),
    marginLeft: 0,
    width: "1000px",
  },
}));

const MultiBoardWrapper = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const {children, customer, isAdmin} = props;

  const customerName = customer ? customer.CustomerName : null;
  const customerId = customer ? customer.CustomerId : null;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
      <div className={classes.root}>
        {/*<div className={classes.appFrame}>*/}
          {/*<CssBaseline />*/}
          <AppBar
              position="sticky"
              className={clsx('', classes.appBar, {
                [classes.appBarShift]: open,
              })}
          >
            <Toolbar>
              <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  className={clsx(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap className={"text-white"}>
                {customerName? isAdmin? `${customerName} (${customerId})` : `${customerName}` : `Loading...`}
              </Typography>
            </Toolbar>
          </AppBar>
          <Drawer
              className={classes.drawer}
              variant="persistent"
              anchor="left"
              open={open}
              classes={{
                paper: classes.drawerPaper,
              }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={handleDrawerClose}>
                Your Boards
                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
            <Divider />
            <List>
              <CustomersAsListItems/>
            </List>
          </Drawer>
          <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
          >
            <div className={classes.drawerHeader}  />
            {children}
          </main>
        {/*</div>*/}
      </div>
  );
}

MultiBoardWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  classes: PropTypes.object,
  theme: PropTypes.object,
  customerInView: PropTypes.number
};

// export default withStyles(styles, {withTheme: true})(MultiBoardWrapper);
export default MultiBoardWrapper;